import { get, getText } from '../helpers';
import Store from '../redux/store';

type GA4AnnouncementMetadataValue = string | number | boolean;

const getTrackingUserState = (): string => {
    const state = Store.getState();
    const isLoggedIn = get(state, 'user.isLoggedIn', false);

    return isLoggedIn ? 'authenticated' : 'anonymous';
};

const getTrackingUserId = (): string => {
    const state = Store.getState();
    const isLoggedIn = get(state, 'user.isLoggedIn', false);

    if (isLoggedIn) {
        return get(state, 'user.userInfo.KeyOnlineUser', '') || '';
    }

    return 'Anonymous';
};

const getTrackingPageLanguage = (): string => {
    const langCode = getText('langCode');
    return langCode;
};

export default function pushGA4AnnouncementEvent(
    eventName: string,
    metadata: Record<string, GA4AnnouncementMetadataValue> = {}
) {
    if (typeof window === 'undefined') {
        return;
    }

    const { dataLayer } = window as Window & {
        dataLayer?: { push: (event: Record<string, GA4AnnouncementMetadataValue>) => void };
    };

    if (!dataLayer || typeof dataLayer.push !== 'function') {
        return;
    }

    const userId = getTrackingUserId();
    const userState = getTrackingUserState();
    const pageLanguage = getTrackingPageLanguage();

    dataLayer.push({
        event: eventName,
        UserID: userId,
        userState,
        page_language: pageLanguage,
        Timestamp: new Date().toISOString(),
        ...metadata,
    });
}
